import { create } from 'zustand';

const useEvacuationStore = create((set, get) => ({
  // ==================== MAP STORE ====================
  layerRegistry: {
    static: {},   // From useEvacuationLayers()
    dynamic: {},  // From useCreateEvacuationOrder() (google route)
  },

  visibleLayers: {},

  setVisibleLayers: (layers) => {
    set({ visibleLayers: layers });
  },

  clearVisibleLayers: () => {
    set({ visibleLayers: {} });
  },

  setStaticLayers: (layers) => {
    set((state) => ({
      layerRegistry: {
        ...state.layerRegistry,
        static: layers,
      }
    }));
  },

  addDynamicLayer: (layerId, geoJsonData, options = {}) => {
    set((state) => ({
      layerRegistry: {
        ...state.layerRegistry,
        dynamic: {
          ...state.layerRegistry.dynamic,
          [layerId]: {
            data: geoJsonData,
            linkedTo: options.linkedTo || null,
            clearOn: options.clearOn || 'manual',
            timestamp: Date.now(),
          }
        }
      }
    }));
  },

  replaceDynamicLayers: (newLayers) => {
    set((state) => {
      console.log('🔄 Replacing all dynamic layers');
      return {
        layerRegistry: {
          ...state.layerRegistry,
          dynamic: newLayers  // Complete replacement
        }
      };
    });
  },

  removeDynamicLayer: (layerId) => {
    set((state) => {
      if (!state.layerRegistry.dynamic[layerId]) {
        console.warn(`Layer "${layerId}" not found in dynamic registry`);
        return state;
      }

      const { [layerId]: removed, ...rest } = state.layerRegistry.dynamic;
      return {
        layerRegistry: {
          ...state.layerRegistry,
          dynamic: rest
        }
      };
    });
  },

  clearDynamicLayersByRule: (rule, context) => {
    set((state) => {
      const filtered = Object.entries(state.layerRegistry.dynamic)
        .filter(([key, layer]) => {
          if (rule === 'deselect' && layer.clearOn === 'deselect') {
            return layer.linkedTo !== context.zoneId;
          }
          if (rule === 'new_selection' && layer.clearOn === 'new_selection') {
            return false;
          }
          return true;
        })
        .reduce((acc, [key, layer]) => ({ ...acc, [key]: layer }), {});

      return {
        layerRegistry: {
          ...state.layerRegistry,
          dynamic: filtered
        }
      };
    });
  },

  clearDynamicLayers: () => {
    set((state) => {
      console.log('🗑️ Clearing dynamic layers only');
      return {
        layerRegistry: {
          ...state.layerRegistry,
          dynamic: {},
        },
        selectionContext: {
          zoneId: null,
          zoneLayer: null,
          routeLayer: null,
          musterStationLayer: null,
          musterCoordinates: null,
          musterName: null,
          musterAddress: null,
        },
        currentOrder: null,
      };
    })
  },

  clearLayerRegistry: () => {
    set(() => {
      return {
        layerRegistry: {
          static: {},
          dynamic: {},
        },
      };
    })
  },

  clearAll: () => {
    const store = get();

    store.clearLayerRegistry();
    store.clearSelectionContext();
    store.clearCurrentOrder();
    store.clearVisibleLayers();
    store.clearFeatureRequest();
  },

  // ==================== SELECTION ====================
  featureRequest: {},

  selectionContext: {
    zoneId: null,
    zoneLayer: null,
    routeLayer: null,
    musterStationLayer: null,
    musterCoordinates: null,
    musterName: null,
    musterAddress: null,
  },

  setSelectionContext: (context) => {
    set({ selectionContext: context });
  },

  updateSelectionContext: (updates) => {
    set((state) => ({
      selectionContext: {
        ...state.selectionContext,
        ...updates,
      }
    }));
  },

  clearSelectionContext: () => {
    set({
      selectionContext: {
        zoneId: null,
        zoneLayer: null,
        routeLayer: null,
        musterStationLayer: null,
        musterCoordinates: null,
        musterName: null,
        musterAddress: null,
      }
    });
  },

  setFeatureRequest: (featureRequest) => {
    set({ featureRequest });
  },

  clearFeatureRequest: () => {
    set({ featureRequest: {} });
  },

  // ==================== ORDERS ====================
  currentOrder: null,
  isLoadingOrder: false,

  setLoadingOrder: (loading) => {
    set({ isLoadingOrder: loading });
  },

  setCurrentOrder: (order) => {
    set({ currentOrder: order });
  },

  clearCurrentOrder: () => {
    set({ currentOrder: null });
  },

  // ==================== EVENT RELATED ====================
  zonesData: [],
  isLoadingZoneStatuses: true, // Defaults true so the map overlay doesn't flash before EvacuationPortalDetails reports the real state

  setZonesData: (zones) => {
    set({ zonesData: zones });
  },

  clearZonesData: () => {
    set({ zonesData: [] });
  },

  setLoadingZoneStatuses: (loading) => {
    set({ isLoadingZoneStatuses: loading });
  },
}));



export default useEvacuationStore;